import noUiSlider from 'nouislider';

window.noUiSlider = noUiSlider;